import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiApplicationsService } from '../../../../services/applications/api/api-applications.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-application-edit-modal',
  templateUrl: './application-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class ApplicationEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  applicationId: number = 0;
  name: string = '';

  private callbackSaved?: () => void;

  constructor(private apiApplicationsService: ApiApplicationsService, private alertsService: AlertsService) {}

  show(applicationId: number, name: string, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.applicationId = applicationId;
    this.name = name;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiApplicationsService.editApplication(this.applicationId, this.name).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Application updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating application : ' + error);
      }
    );
  }
}
